import { useMemo } from 'react';
import { useIntl } from 'react-intl';

export function useCardContent(channel: string) {
  const intl = useIntl();

  return useMemo(() => {
    switch (channel) {
      case 'boost':
        return {
          title: intl.formatMessage({ defaultMessage: 'Boost My Job' }),
          description: intl.formatMessage({
            defaultMessage:
              'Fountain Boost automatically posts your job to hundreds of job boards.',
          }),
        };
      case 'indeed':
        return {
          title: intl.formatMessage({ defaultMessage: 'Post to Indeed' }),
          description: intl.formatMessage({
            defaultMessage:
              'Directly sponsor your job on Indeed and receive applicants in Fountain.',
          }),
        };
      case 'spring':
        return {
          title: intl.formatMessage({
            defaultMessage: 'Acquire Global Talent',
          }),
          description: intl.formatMessage({
            defaultMessage:
              'Fountain Spring provides job-specific recommendations to sponsor openings to thousands of diverse channels.',
          }),
        };
      case 'reach':
        return {
          title: intl.formatMessage({
            defaultMessage: 'Leverage Fountain Reach',
          }),
          description: intl.formatMessage({
            defaultMessage:
              'Uncover quality candidates swiftly and precisely with AI-powered sourcing.',
          }),
        };
      case 'joveo':
        return {
          title: intl.formatMessage({ defaultMessage: 'Post to Joveo' }),
          description: intl.formatMessage({
            defaultMessage:
              'Joveo is an AI-led, high-performance recruitment marketing platform.',
          }),
        };
      default:
        return null;
    }
  }, [channel, intl]);
}
